import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import useElementDimensions from '../../../hooks/useElementDimensions';
import { DEFAULT_LARGE_TRANSITION_DURATION_MS } from '../../../constants/statics';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const TRANSITION_DELAY_MS = 30;
const HorizontalExpander = ({ children, maxWidth, transitionDurationMs = DEFAULT_LARGE_TRANSITION_DURATION_MS, }) => {
    const animationTimeoutRef = useRef(null);
    const cleanupTimeoutRef = useRef(null);
    const [prevWidth, setPrevWidth] = useState(0);
    const [animating, setAnimating] = useState(false);
    const content = useRef(null);
    const rect = useElementDimensions(content);
    useEffect(() => {
        if (rect?.width && rect.width !== prevWidth && !animating) {
            setPrevWidth(rect.width);
        }
    }, [rect?.width, animating, prevWidth]);
    useLayoutEffect(() => {
        if (typeof window === 'undefined')
            return;
        if (content.current && !animating) {
            const currentWidth = rect?.width || 0;
            if (currentWidth !== prevWidth && !animating) {
                setAnimating(true);
                if (animationTimeoutRef.current) {
                    clearTimeout(animationTimeoutRef.current);
                    animationTimeoutRef.current = null;
                }
                if (cleanupTimeoutRef.current) {
                    clearTimeout(cleanupTimeoutRef.current);
                    cleanupTimeoutRef.current = null;
                }
                content.current.style.width = `${prevWidth || rect?.width}px`;
                animationTimeoutRef.current = setTimeout(() => {
                    if (content.current) {
                        content.current.style.width = `${currentWidth}px`;
                    }
                    cleanupTimeoutRef.current = setTimeout(() => {
                        if (content.current) {
                            if (!maxWidth || currentWidth < maxWidth) {
                                content.current.style.width = 'fit-content';
                            }
                            else {
                                content.current.style.width = '';
                            }
                        }
                        setAnimating(false);
                    }, transitionDurationMs + TRANSITION_DELAY_MS);
                }, TRANSITION_DELAY_MS);
            }
        }
    }, [rect?.width, prevWidth, animating]);
    return (_jsx("div", { className: cx('horizontal-expander'), children: _jsx("div", { ref: content, className: cx('horizontal-expander-content'), style: {
                maxWidth: maxWidth ? `${maxWidth}px` : 'none',
                transition: `width ${transitionDurationMs}ms ease-in-out`,
            }, children: children }) }));
};
export default HorizontalExpander;
//# sourceMappingURL=index.js.map